import React from 'react';
import { StatsPanel } from './../StatsPanel';
import { SubcategorySelectionPanel } from './../SubcategorySelectionPanel';
import { AutoLexiSeparator } from './../AutoLexiSeparator';
import './SidePanels.css';

// Sprite is 1536×1024 with 4 cells, scaled to background-size: 384px auto (96px per cell).
// Each offset is inset 6px from the theoretical cell boundary to skip outer-edge sprite padding.
// start=16, step=84 (derived from first two anchor points 16 and 100)
const SPRITE_OFFSETS_PX = [19, 102, 185, 268];

const SPRITE_FILE = (() => {
  const n = new Date().getDate() % 3;
  return `spritePanel${n === 0 ? 3 : n}.png`;
})();

const SpriteIcon = ({ index, position }) => (
  <div
    className={`panel-sprite-icon panel-sprite-icon-${position}`}
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/${SPRITE_FILE})`,
      backgroundPosition: `-${SPRITE_OFFSETS_PX[index]}px 50%`,
    }}
  />
);

const SidePanels = () => (
  <>
    <div className="side-panel side-panel-left">
      <AutoLexiSeparator />
      <SpriteIcon index={0} position="top" />
      <div className="panel-content">
        <StatsPanel />
      </div>
      <SpriteIcon index={1} position="bottom" />
      <AutoLexiSeparator flip />
    </div>
    <div className="side-panel side-panel-right">
      <AutoLexiSeparator />
      <SpriteIcon index={2} position="top" />
      <div className="panel-content">
        <SubcategorySelectionPanel />
      </div>
      <SpriteIcon index={3} position="bottom" />
      <AutoLexiSeparator flip />
    </div>
  </>
);

export { SidePanels };
